import CCLineChart from "../Common/CCLineChart";
import {prepareBuffer} from "../../util/Buffer";

class ExampleLineChart extends CCLineChart {
    constructor(props) {
        super(props);

        this.state.fetchBackgroundOperation = false
    };

    componentDidMount() {
        super.componentDidMount();

        const uData = [3000, 3000, 2000, 2780, 1890, 2390, 3490];
        const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
        const xLabels = [
          'Page A',
          'Page B',
          'Page C',
          'Page D',
          'Page E',
          'Page F',
          'Page G',
        ];

        let series = structuredClone(this.props.Series ?? [{}, {}]);
        series[0].data = pData;
        series[1].data = uData;

        let xAxis;
        if (this.state.xAxis === undefined) {
            xAxis = []
        } else {
            xAxis = structuredClone(this.state.xAxis);
        }

        if (xAxis.size === 0) {
            xAxis.push({
                "scaleType": 'point',
            })
        }
        xAxis[0].data = xLabels;

        this.setState({Loading: this.state.fetchBackgroundOperation, Series: series, xAxis: xAxis});

        this.applet.getEnterpriseComponent().executeQuery(1,100000);
    }

    enterpriseComponentLoadStarted = () => {
        this.setState({Loading: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);

        let xAxis = structuredClone(this.state.xAxis);
        xAxis[0].data = []
        for (let i = 0; i < buffer.length; i++) {
            xAxis[0].data.push(buffer[i].get("X_AXIS"));
        }

        let series = structuredClone(this.state.Series);
        if (series.length === 0) {
            series = [{data: []}, {data: []}]
        }
        series[0].data = []
        for (let i = 0; i < buffer.length; i++) {
            series[0].data.push(parseInt(buffer[i].get("Y_AXIS_2")));
        }
        series[1].data = []
        for (let i = 0; i < buffer.length; i++) {
            series[1].data.push(parseInt(buffer[i].get("Y_AXIS_1")));
        }

        this.setState({Loading: false, Series: series, xAxis: xAxis});
    };


}

export default ExampleLineChart;